export const isLoggedIn = (state) => state.auth.isLoggedIn;
export const getIsBDM = (state) => state.auth.isBDM;
export const getUserData = (state) => state.auth;